
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.se-share-quote{
  font-family:var(--ff-dmsans);
  display:grid;
  width:100%;
  justify-content:center;
  grid-template-areas:'icon quote '
    '. share';
  column-gap:var(--spacing-4);
  background-color:var(--brand-secondary-4);
  padding:var(--spacing-7);
  font-size:var(--fs-xl);
  font-weight:var(--fw-medium);
}

  @media (min-width: 768px){.se-share-quote{
    column-gap:var(--spacing-10);
    padding:var(--spacing-14);
    grid-template-columns:auto 50%;
    font-size:var(--fs-2xl)
}
  }

  .se-share-quote outline-icon[name='quote']{
    grid-area:icon;
  }

  .se-share-quote .quote{
    grid-area:quote;
    justify-self:start;
    margin:0;
  }

  @media (min-width: 768px){

  .se-share-quote .quote{
      margin:var(--spacing-3) 0
  }
    }

  .se-share-quote .share-btn{
    grid-area:share;
  }

  .se-share-quote .share-btn outline-icon[name='twitter']{
      padding-left:var(--spacing-5);
    }

  .se-share-quote .share-btn{

    padding-top:var(--spacing-5);
}

  @media (min-width: 768px){

  .se-share-quote .share-btn{
      justify-self:end;
      padding-top:0
  }
      .se-share-quote .share-btn se-button{
        justify-content:flex-end;
      }
    }
`;